export default "__VITE_ASSET__Cb_NT$rP__"